export function formatDates(formation, isPro = false) {
    let { start, end } = format(formation, isPro);
    return `${start} ${end}`;
}

export function formatDatesWithSeparator(formation, isPro = false) {
  let { start, end } = format(formation, isPro);
  return end === "" ? `${start}` : `${start} - ${end}`;
}

function format(formation, isPro = false) {
  const [start, end] = [
    formation.value.value.debut_parcours,
    formation.value.value.fin_parcours,
  ];
  const [hasStart, hasEnd] = [!!start, !!end];
  const [startDate, endDate] = [new Date(start), new Date(end)];

  const isSameYear =
    startDate.getFullYear() === endDate.getFullYear();

  const isSameMonth =
    startDate.getMonth() === endDate.getMonth();

  let formatOptions = {};
  if (isSameYear && isSameMonth) {
    formatOptions = { month: "long", year: "numeric" };
  } else {
    formatOptions = { month: "2-digit", year: "numeric" };
  }


  const [formattedStart, formattedEnd] = [startDate, endDate].map(
    (date) => date.toLocaleDateString('fr-FR', formatOptions)
  );

  const endOrEmpty = hasEnd ? (isSameYear ? (isSameMonth ? "": formattedEnd) : formattedEnd) : "";
  const startOrEmpty = hasStart ? formattedStart : "";



  if (isPro) {
    const prefix = hasEnd ? "" : "DEPUIS ";
    const startWithPrefixOrEmpty = hasStart
      ? `${prefix}${formattedStart}`
      : "";

    return {start: startWithPrefixOrEmpty, end: endOrEmpty};
  }

  return {start: startOrEmpty, end: endOrEmpty};

}
